import { render } from "./InternationalPhoneInput.vue?vue&type=template&id=0139f63a&scoped=true"
import script from "./InternationalPhoneInput.vue?vue&type=script&lang=js"
export * from "./InternationalPhoneInput.vue?vue&type=script&lang=js"

import "./InternationalPhoneInput.vue?vue&type=style&index=0&id=0139f63a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0139f63a"]])

export default __exports__